import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import Splash from './components/Splash';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import MediaCenterPage from './pages/MediaCenterPage';
import SectorPage from './pages/sectors/SectorPage';
import { sectors } from './pages/sectors/sectorsData';

export default function App() {
  return (
    <LanguageProvider>
      <Splash />
      <HashRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route index element={<HomePage />} />
            <Route path="about" element={<AboutPage />} />
            <Route path="contact" element={<ContactPage />} />
            <Route path="media" element={<MediaCenterPage />} />
            {sectors.map((s) => (
              <Route key={s.slug} path={s.route.slice(1)} element={<SectorPage data={s} />} />
            ))}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </HashRouter>
    </LanguageProvider>
  );
}
